var React = require('react');

function Hexagon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M539.27673106 467.52508558L270.50046642 622.70313101 1.72420002 467.52508061l-.00000176-310.35609583L270.50046506 1.99093561l268.7762664 155.1780504z"}));
}

Hexagon.defaultProps = {"viewBox":"0 0 541.00092 624.69409"};

module.exports = Hexagon;

Hexagon.default = Hexagon;
